import JackpotsReport from "./JackpotsReport";

export default JackpotsReport;
